(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ergometric-bestsellers"] && !Shopify.designMode) return;
  try {
    
function setupBestsellers(root=document){root.querySelectorAll('.em-best').forEach(section=>{if(section.dataset.ready)return;section.dataset.ready='true';const track=section.querySelector('.em-best-track'),prev=section.querySelector('[data-em-prev]'),next=section.querySelector('[data-em-next]'),pause=section.querySelector('[data-em-pause]'),reduce=matchMedia('(prefers-reduced-motion: reduce)');let paused=reduce.matches,hovered=false,focused=false;
const update=()=>{const fits=track.scrollWidth<=track.clientWidth+5;prev.disabled=fits;next.disabled=fits;pause.disabled=fits;pause.setAttribute('aria-pressed',String(paused));pause.setAttribute('aria-label',paused?'Play carousel':'Pause carousel');pause.textContent=paused?'▶':'Ⅱ'};
const move=direction=>{const card=track.querySelector('.em-best-card');if(!card)return;const step=card.getBoundingClientRect().width+parseFloat(getComputedStyle(track).columnGap);const max=track.scrollWidth-track.clientWidth;let left=track.scrollLeft+direction*step;if(direction>0&&track.scrollLeft>=max-5)left=0;if(direction<0&&track.scrollLeft<=5)left=max;track.scrollTo({left,behavior:reduce.matches?'auto':'smooth'})};
prev.addEventListener('click',()=>move(-1));next.addEventListener('click',()=>move(1));pause.addEventListener('click',()=>{paused=!paused;update()});section.addEventListener('mouseenter',()=>hovered=true);section.addEventListener('mouseleave',()=>hovered=false);section.addEventListener('focusin',()=>focused=true);section.addEventListener('focusout',event=>{focused=section.contains(event.relatedTarget)});reduce.addEventListener('change',()=>{if(reduce.matches)paused=true;update()});const observer=new ResizeObserver(update);observer.observe(track);const timer=setInterval(()=>{if(!section.isConnected){clearInterval(timer);observer.disconnect();return}const bounds=section.getBoundingClientRect();if(!paused&&!hovered&&!focused&&!document.hidden&&bounds.top<innerHeight&&bounds.bottom>0)move(1)},5000);update()})}
setupBestsellers();document.addEventListener('shopify:section:load',()=>setupBestsellers());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-promotions"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('ergometric-promotions')){
    customElements.define('ergometric-promotions',class extends HTMLElement{
      connectedCallback(){
        this.slides=[...this.querySelectorAll('[data-slide]')];this.tabs=[...this.querySelectorAll('[data-select]')];this.pause=this.querySelector('[data-pause]');this.index=0;this.stopped=matchMedia('(prefers-reduced-motion: reduce)').matches;this.hovered=false;this.focused=false;this.abort=new AbortController();const opts={signal:this.abort.signal};
        this.tabs.forEach((b,i)=>b.addEventListener('click',()=>{this.show(i);this.schedule()},opts));
        this.pause?.addEventListener('click',()=>{this.stopped=!this.stopped;this.paintPause();this.schedule()},opts);
        this.addEventListener('mouseenter',()=>{this.hovered=true;this.schedule()},opts);this.addEventListener('mouseleave',()=>{this.hovered=false;this.schedule()},opts);
        this.addEventListener('focusin',()=>{this.focused=true;this.schedule()},opts);this.addEventListener('focusout',e=>{if(!this.contains(e.relatedTarget)){this.focused=false;this.schedule()}},opts);
        document.addEventListener('visibilitychange',()=>this.schedule(),opts);
        this.addEventListener('shopify:block:select',e=>{const i=this.slides.indexOf(e.target.closest('[data-slide]'));if(i>=0){this.stopped=true;this.show(i);this.paintPause();this.schedule()}},opts);
        this.paintPause();this.schedule();
      }
      show(i){this.index=i;this.slides.forEach((s,n)=>{s.classList.toggle('is-active',n===i);s.inert=n!==i;s.setAttribute('aria-hidden',String(n!==i));if(n===i)this.tabs[n].setAttribute('aria-current','true');else this.tabs[n].removeAttribute('aria-current')})}
      paintPause(){if(!this.pause)return;this.pause.setAttribute('aria-label',this.stopped?this.pause.dataset.play:this.pause.dataset.stop);this.pause.firstElementChild.textContent=this.stopped?'▷':'Ⅱ'}
      schedule(){clearTimeout(this.timer);if(!this.stopped&&!this.hovered&&!this.focused&&!document.hidden&&this.slides.length>1)this.timer=setTimeout(()=>{this.show((this.index+1)%this.slides.length);this.schedule()},Number(this.dataset.delay)||6500)}
      disconnectedCallback(){clearTimeout(this.timer);this.abort?.abort()}
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
